import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Chip from '@mui/material/Chip';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { useAppXrResource } from './useAppXrResource';

export const AppConfigCard = () => {
  const { resource, loading } = useAppXrResource();
  const spec = resource?.spec;

  if (loading || !spec) return null;

  const rowSx = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    py: 0.5,
  };
  const labelSx = { color: 'text.secondary', fontSize: '0.85rem' };
  const valueSx = { fontSize: '0.85rem', fontFamily: 'monospace' };

  return (
    <Card>
      <CardHeader title="App Configuration" />
      <CardContent>
        <Box sx={rowSx}>
          <Typography sx={labelSx}>Port</Typography>
          <Typography sx={valueSx}>{spec.port ?? '—'}</Typography>
        </Box>
        <Box sx={rowSx}>
          <Typography sx={labelSx}>Size</Typography>
          <Typography sx={valueSx}>{spec.size ?? '—'}</Typography>
        </Box>
        <Box sx={rowSx}>
          <Typography sx={labelSx}>Replicas</Typography>
          <Typography sx={valueSx}>{spec.replicas ?? '—'}</Typography>
        </Box>
        {spec.healthCheck?.path && (
          <Box sx={rowSx}>
            <Typography sx={labelSx}>Health Check</Typography>
            <Typography sx={valueSx}>{spec.healthCheck.path}</Typography>
          </Box>
        )}
        {spec.ingress?.host && (
          <Box sx={rowSx}>
            <Typography sx={labelSx}>Ingress</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
              <Link
                href={`https://${spec.ingress.host}`}
                target="_blank"
                rel="noopener"
                sx={valueSx}
              >
                {spec.ingress.host}
              </Link>
              {spec.ingress.iap ? (
                <Chip
                  icon={<LockIcon sx={{ fontSize: 14 }} />}
                  label="IAP"
                  size="small"
                  color="primary"
                  variant="outlined"
                  sx={{ height: 20, '& .MuiChip-label': { px: 0.5 } }}
                />
              ) : (
                <Chip
                  icon={<LockOpenIcon sx={{ fontSize: 14 }} />}
                  label="Public"
                  size="small"
                  variant="outlined"
                  sx={{ height: 20, '& .MuiChip-label': { px: 0.5 } }}
                />
              )}
            </Box>
          </Box>
        )}
        {spec.args && spec.args.length > 0 && (
          <Box sx={rowSx}>
            <Typography sx={labelSx}>Args</Typography>
            <Typography sx={valueSx}>{spec.args.join(' ')}</Typography>
          </Box>
        )}
        {spec.env && spec.env.length > 0 && (
          <Box sx={{ mt: 1 }}>
            <Typography sx={labelSx} gutterBottom>
              Environment
            </Typography>
            {spec.env.map(e => (
              <Box key={e.name} sx={{ ...rowSx, py: 0.25 }}>
                <Typography sx={{ ...valueSx, color: 'text.secondary' }}>
                  {e.name}
                </Typography>
                <Typography sx={valueSx}>{e.value}</Typography>
              </Box>
            ))}
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
